module.exports = __webpack_public_path__ + "static/media/COC.db5e534e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/COC.svg
// module id = 230
// module chunks = 0